import { render, staticRenderFns } from "./stock-detail-table.vue?vue&type=template&id=dd15d5d6&"
import script from "./stock-detail-table.vue?vue&type=script&lang=js&"
export * from "./stock-detail-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports